import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  Image,
  FlatList,
  ListRenderItemInfo,
} from 'react-native';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';
import {Payload} from 'recharts/types/component/DefaultTooltipContent';
import {StudentType} from 'services/API/ClassApi/ClassApiModels';
import {propTypes} from 'react-spinkit';
import {useAnalyticsStore} from 'contexts/StoreContext';

interface TooltipProps {
  payload: Payload<number, string>[];
  label: string;
  active: boolean;
  colors: string[];
  backgroundColor?: string;
  isShadow?: boolean;
  students: StudentType[];
}

const ChartTooltip = ({
  payload,
  label,
  active,
  colors,
  backgroundColor,
  isShadow,
  students,
}: TooltipProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const renderItem = (
    itemProps: ListRenderItemInfo<Payload<number, string>>,
  ) => {
    return (
      <View style={styles.tooltipItemWrapper}>
        <View
          style={[
            styles.colorBlock,
            {backgroundColor: colors[itemProps.index + 1]},
          ]}
        />
        <Text style={styles.tooltipTextStyle}>
          {students[itemProps.index].firstname +
            ' ' +
            students[itemProps.index].lastname +
            ':'}
        </Text>
        <Text style={styles.toolipHeaderAndPercentTextStyle}>
          {itemProps.item.value}
        </Text>
      </View>
    );
  };

  if (active) {
    return (
      <View
        style={[
          isShadow ? styles.tooltipWrapper : styles.tooltipWrapperNoShadow,
          {
            backgroundColor: backgroundColor
              ? backgroundColor
              : theme.colors.lavenderWeb,
          },
        ]}>
        <Text style={styles.toolipHeaderAndPercentTextStyle}>Time {label}</Text>
        <FlatList
          data={payload}
          renderItem={renderItem}
          keyExtractor={(item, index) => `${item.dataKey} ${index}`}
        />
      </View>
    );
  }

  return null;
};

export default ChartTooltip;
